/** @file Thai catalog part of area E1 (W3-03), partial; replaced whole by that area. */

/** The `tools.<id>.title` keys of the seven E1 tools (spread into `tools`); partial, English fills the gaps. S0 composes it into `th`. */
export const toolsTh = {
  select: { title: 'เลือก' },
  translate: { title: 'ย้าย' },
  rotate: { title: 'หมุน' },
  scale: { title: 'ย่อขยาย' },
  createBone: { title: 'สร้างกระดูก' },
  ik: { title: 'IK' },
  grabItem: { title: 'จับไอเท็ม' },
} as const;
